/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseMultiFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/General/BaseMultiFormElement";
import {evaluateFormFormula} from "@/utils/helpers.js";

export default class FormElementRadioButtons extends BaseMultiFormElement {

	selectedIndex: number = -1

	constructor(title, isRequired) {
		super(FormElementType.RADIOBUTTONS, title, isRequired);
	}

	numberOfAnswers(){
		return this.selectedIndex >= 0 ? 1 : 0
	}


	_calculateAnswerScoreAsBuckets(formItem){
		let res = []
		for(let i = 0; i < this.answerOptionsScoring.length; ++i){
			if(i === this.selectedIndex){
				let score = this.computeResultScore(this.answerOptionsScoring[i])
				res.push(score)
			} else {
				res.push(0)
			}
		}
		return res
	}

	_calculateAnswerScoreAsTotal(formItem){
		let score = 0
		if(this.selectedIndex >= 0 && this.selectedIndex < this.answerOptionsScoring.length){
			score = this.computeResultScore(this.answerOptionsScoring[this.selectedIndex])
		}
		return score
	}



	calculateMaxScore() {
		if(this.answerOptionsScoring.length === 0) {
			return 0
		}
		let scoringCalculated = this.answerOptionsScoring.map((scoreFormula) => {
			console.log("scoreFormula = ", scoreFormula)
			return this.computeResultScore(scoreFormula)
		})
		return Math.max(...scoringCalculated)
	}

}
